var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-end mt-5"},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"16","color":"gray"}},[_vm._v(" fas fa-chevron-circle-right ")]),_c('a',{attrs:{"href":_setup.linkMyTasks}},[_vm._v(" "+_vm._s(_vm.$t('task.manager.see.mine'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }